import cn from 'classnames'
import {
  IContentActions,
  IContentMessages,
  IPartnerDuplicatesRowAttribute,
} from 'legacy/lut/components/widgets/public/partnerDuplicates/models'
import React, { FC, useCallback } from 'react'

import { IPartner, IPartnerDuplicate, TPartnerDifference } from 'clickNgo/entities/partner/models'

import { ApolloMatchesRowContent } from './components/apolloMatchesRowContent/ApolloMatchesRowContent'

import styles from './ApolloMatchRow.module.scss'

interface IApolloMatchRowProps
  extends IPartnerDuplicatesRowAttribute,
    IContentActions,
    IContentMessages {
  searchResult: IPartnerDuplicate
  isOpened: boolean
  changeTabsOpeningState: (key: string) => void
  onSelect?: (item: IPartner) => void
  onPartialReplace?: (field: keyof IPartner, newValue: string, partner: IPartner) => void
  sortDifference?: (a: TPartnerDifference, b: TPartnerDifference) => number
}

export const ApolloMatchRow: FC<IApolloMatchRowProps> = ({
  searchResult,
  changeTabsOpeningState,
  isOpened,
  rowAttrs,
  rowState,
  additional,
  renderChildren,
  onPartialReplace,
  onSelect,
  contentActions,
  contentMessages,
  sortDifference,
}) => {
  const onRowClickHandler = useCallback(() => {
    changeTabsOpeningState(rowAttrs?.key)
    if (onSelect) {
      onSelect(searchResult.partner)
    }
  }, [rowAttrs?.key, changeTabsOpeningState, onSelect, searchResult])

  return (
    <>
      <tr
        {...rowAttrs}
        className={cn(rowAttrs.className, styles.row, { [styles.selected]: isOpened })}
        onClick={onRowClickHandler}
      >
        {renderChildren(searchResult, rowState, additional)}
      </tr>

      {isOpened && (
        <tr className={cn({ [styles.expanded]: isOpened })}>
          <td colSpan={11}>
            <ApolloMatchesRowContent
              searchResult={searchResult}
              onPartialReplace={onPartialReplace}
              contentActions={contentActions}
              contentMessages={contentMessages}
              sortDifference={sortDifference}
            />
          </td>
        </tr>
      )}
    </>
  )
}
